var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDdx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_262_32801)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#7742FE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L32.5 13.5L35.5 17.25L38.5 21.75L37 40.5H19V15Z",
    fill: "#C6AFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.61 19.995L32.95 12.495C32.8098 12.3396 32.6385 12.2153 32.4474 12.13C32.2562 12.0448 32.0493 12.0005 31.84 12H19.84C19.3416 11.9941 18.847 12.0863 18.3843 12.2716C17.9215 12.4568 17.4999 12.7314 17.1433 13.0796C16.7867 13.4279 16.5022 13.8429 16.306 14.3011C16.1099 14.7593 16.0059 15.2516 16 15.75V38.25C16.0059 38.7484 16.1099 39.2407 16.306 39.6989C16.5022 40.1571 16.7867 40.5721 17.1433 40.9204C17.4999 41.2686 17.9215 41.5432 18.3843 41.7284C18.847 41.9137 19.3416 42.0059 19.84 42H36.16C36.6584 42.0059 37.153 41.9137 37.6157 41.7284C38.0785 41.5432 38.5001 41.2686 38.8567 40.9204C39.2133 40.5721 39.4978 40.1571 39.694 39.6989C39.8901 39.2407 39.9941 38.7484 40 38.25V21C39.999 20.6282 39.86 20.2701 39.61 19.995ZM23.5 27H28C28.3978 27 28.7794 27.158 29.0607 27.4393C29.342 27.7206 29.5 28.1022 29.5 28.5C29.5 28.8978 29.342 29.2794 29.0607 29.5607C28.7794 29.842 28.3978 30 28 30H23.5C23.1022 30 22.7206 29.842 22.4393 29.5607C22.158 29.2794 22 28.8978 22 28.5C22 28.1022 22.158 27.7206 22.4393 27.4393C22.7206 27.158 23.1022 27 23.5 27ZM32.5 36H23.5C23.1022 36 22.7206 35.842 22.4393 35.5607C22.158 35.2794 22 34.8978 22 34.5C22 34.1022 22.158 33.7206 22.4393 33.4393C22.7206 33.158 23.1022 33 23.5 33H32.5C32.8978 33 33.2794 33.158 33.5607 33.4393C33.842 33.7206 34 34.1022 34 34.5C34 34.8978 33.842 35.2794 33.5607 35.5607C33.2794 35.842 32.8978 36 32.5 36ZM32.065 21C31.7558 20.9695 31.4709 20.8188 31.2717 20.5804C31.0725 20.3419 30.9749 20.0347 31 19.725V15L36.61 21H32.065Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 15.9993C43 15.9993 43 15.9992 43 15.9992C43 13.7905 41.1868 12 38.95 12C37.9127 12 36.9665 12.3851 36.25 13.0183C35.5335 12.3851 34.5873 12 33.55 12C31.3132 12 29.5 13.7905 29.5 15.9992C29.5 15.9993 29.5 15.9993 29.5 15.9993C29.5 20.8991 34.0032 23.202 35.6533 23.8813C36.0377 24.0396 36.4623 24.0396 36.8467 23.8813C38.4968 23.202 43 20.8991 43 15.9993Z",
    fill: "#C6AFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 17.3333H39.7939L38.942 15.4041C38.8337 15.1589 38.5854 15 38.3106 15C38.0359 15 37.7875 15.1589 37.6793 15.4041L36.25 18.6409L35.851 17.7374C35.7428 17.4923 35.4945 17.3333 35.2197 17.3333H29.5C29.5864 17.8061 29.7172 18.2502 29.8832 18.6667H34.7668L35.6187 20.5959C35.7269 20.8411 35.9752 21 36.25 21C36.5248 21 36.7731 20.8411 36.8813 20.5959L38.3106 17.3591L38.7096 18.2626C38.8178 18.5077 39.0662 18.6667 39.3409 18.6667H42.6168C42.7828 18.2502 42.9136 17.8061 43 17.3333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_262_32801",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_262_32801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_262_32801",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdx);
export default __webpack_public_path__ + "static/media/ddx.4c36281c1a4168bb372ddfe7fb15bc83.svg";
export { ForwardRef as ReactComponent };